import React from 'react'
import BasicLayout from './Layout/BasicLayout'
import Home from './pages/Home'
import Ingreso from './pages/Ingreso'
import Terminos from './pages/Terminos'
import DeclaracionJurada from './Layout/DeclaracionJurada'
import EmisionDeclaracionJurada from './pages/EmisionDeclaracionJurada'
import ReturnEpagos from './pages/ReturnEpagos'
import DeterminacionTasa from './pages/DeterminacionTasa'
import DatosContribuyente from './pages/DatosContribuyente'
import DatosComercial from './pages/DatosComercial'
import DeduccionesExclusiones from './pages/DeduccionesExclusiones'
import Pagos from './pages/Pagos'
import AltaContribuyente from './pages/Alta'
import GestionContribuyente from './pages/GestionContribuyente'
import { StepProvider } from './StepContext'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

function App() {
  return (
    <StepProvider>
      <BasicLayout>
        <BrowserRouter>
          <Switch>
            <Route path="/ddjj/confirmacion-cuit" component={Ingreso} />
            <Route path="/ddjj/alta" component={AltaContribuyente} />
            <Route
              path="/ddjj/gestion-contribuyente"
              component={GestionContribuyente}
            />
            <Route path="/ddjj/return-epagos" component={ReturnEpagos} />
            <Route path="/ddjj/">
              <DeclaracionJurada>
                <Switch>
                  <Route exact path="/ddjj/terminos" component={Terminos} />
                  <Route
                    exact
                    path="/ddjj/datos-contribuyente"
                    component={DatosContribuyente}
                  />
                  <Route
                    exact
                    path="/ddjj/datos-comercial"
                    component={DatosComercial}
                  />
                  <Route
                    exact
                    path="/ddjj/deducciones-exclusiones"
                    component={DeduccionesExclusiones}
                  />
                  <Route exact path="/ddjj/pagos" component={Pagos} />
                  <Route
                    exact
                    path="/ddjj/determinacion-tasa"
                    component={DeterminacionTasa}
                  />
                  <Route
                    exact
                    path="/ddjj/emision-ddjj"
                    component={EmisionDeclaracionJurada}
                  />
                  <Route component={Home} />
                </Switch>
              </DeclaracionJurada>
            </Route>
            <Route component={Home} />
          </Switch>
        </BrowserRouter>
      </BasicLayout>
    </StepProvider>
  )
}

export default App
